let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("h9aqE")).then(() => parcelRequire('gsXh4'));